// Vérification de licence Ed25519 100 % hors-ligne (clé publique embarquée uniquement).
// Le format canonique doit matcher json.dumps(payload, sort_keys=True, separators=(",", ":"))
import nacl from "tweetnacl";

const PUBLIC_KEY = process.env.REACT_APP_LICENSE_PUBLIC_KEY || "";

export function canonicalJson(obj) {
  if (obj === null || typeof obj !== "object") return JSON.stringify(obj);
  if (Array.isArray(obj)) return "[" + obj.map(canonicalJson).join(",") + "]";
  const keys = Object.keys(obj).sort();
  return "{" + keys.map((k) => JSON.stringify(k) + ":" + canonicalJson(obj[k])).join(",") + "}";
}

function ub64(s) {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - (s.length % 4)) % 4);
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

export function parseLicenseText(text) {
  const t = (text || "").trim();
  if (t.startsWith("QLIC1.")) {
    const [, p64, sig] = t.split(".");
    const payload = JSON.parse(new TextDecoder().decode(ub64(p64)));
    return { payload, signature: sig };
  }
  const doc = JSON.parse(t);
  return { payload: doc.payload, signature: doc.signature };
}

export function verifyLicenseSignature(payload, signature) {
  if (!PUBLIC_KEY) return false;
  try {
    const msg = new TextEncoder().encode(canonicalJson(payload));
    return nacl.sign.detached.verify(msg, ub64(signature), ub64(PUBLIC_KEY));
  } catch {
    return false;
  }
}

// Vérification complète hors-ligne : signature + installation + expiration
export function verifyLicenseText(text, installationId) {
  let parsed;
  try {
    parsed = parseLicenseText(text);
  } catch {
    return { ok: false, error: "Fichier ou code de licence illisible" };
  }
  const { payload, signature } = parsed;
  if (!verifyLicenseSignature(payload, signature))
    return { ok: false, error: "Licence invalide ou modifiée" };
  if (installationId && payload.installation_id !== installationId)
    return { ok: false, error: "Cette licence n'est pas valide pour cette installation" };
  if (payload.expires_at && payload.expires_at < new Date().toISOString().slice(0, 10))
    return { ok: false, error: "Cette licence est expirée" };
  return { ok: true, payload };
}
